module.exports = __webpack_public_path__ + "media/bootstrap-icons/circle-square-1e38dadc.svg";